import React from 'react';
import { Bar } from '@ant-design/charts';
import { Card, Empty, Spin } from 'antd';

interface BarChartProps {
  title?: string;
  data: Array<{ date: string; value: number; category?: string }>;
  loading?: boolean;
  height?: number;
  xField?: string;
  yField?: string;
  seriesField?: string;
  yAxis?: {
    title?: string;
    formatter?: (value: number) => string;
  };
  xAxis?: {
    title?: string;
  };
  tooltip?: {
    formatter?: (datum: any) => { name: string; value: string };
  };
  color?: string | string[];
  barStyle?: Record<string, any>;
}

export const BarChart: React.FC<BarChartProps> = ({
  title,
  data,
  loading = false,
  height = 300,
  xField = 'date',
  yField = 'value',
  seriesField,
  yAxis,
  xAxis,
  tooltip,
  color,
  barStyle,
}) => {
  if (loading) {
    return (
      <Card title={title}>
        <div style={{ height, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Spin size="large" />
        </div>
      </Card>
    );
  }

  if (!data || data.length === 0) {
    return (
      <Card title={title}>
        <div style={{ height, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Empty description="No data available" />
        </div>
      </Card>
    );
  }

  const config = {
    data,
    xField,
    yField,
    seriesField,
    height,
    color,
    xAxis: {
      title: xAxis?.title,
      tickCount: 5,
    },
    yAxis: {
      title: yAxis?.title,
      label: yAxis?.formatter
        ? {
            formatter: yAxis.formatter,
          }
        : undefined,
    },
    tooltip: tooltip?.formatter
      ? {
          formatter: tooltip.formatter,
        }
      : undefined,
    legend: seriesField ? { position: 'top' } : false,
    barStyle,
  };

  return (
    <Card title={title}>
      <Bar {...config} />
    </Card>
  );
};

export default BarChart;